import { BrandEnum } from "../_common/enum/brand.enum";


export const originToBrand: Record<string, BrandEnum> = {
    "http://localhost:3000": BrandEnum.Low,
    "https://lowquotes.ie": BrandEnum.LowQuote,
    "https://staging.lowquotes.ie": BrandEnum.LowQuote,
    "https://app.lowquotes.ie": BrandEnum.Low,
    "https://low.ie": BrandEnum.Low,
    "https://hello.lowquotes.ie": BrandEnum.Hello,
    "https://truewealth.ie": BrandEnum.TrueWealth,
    "https://0joqgia.sitepreviewer.ie": BrandEnum.LowQuote,
    "http://0joqgia.sitepreviewer.ie": BrandEnum.LowQuote,
    "http://sitepreviewer.ie": BrandEnum.LowQuote,
    "https://sitepreviewer.ie": BrandEnum.LowQuote
};


export function resolveBrandFromUrl(rawUrl: string): BrandEnum | undefined {
    if (!rawUrl) return undefined;

    let origin: string;

    try {
        origin = new URL(rawUrl).origin;
    } catch {
        origin = rawUrl;
    }

    for (const key of Object.keys(originToBrand)) {
        if (origin.startsWith(key)) {
            return originToBrand[key];
        }
    }

    return undefined;
}

